<template>
  <div>
    <h1>Extratores</h1>
    <b-card>
      <div class="d-flex mb-2">
        <!-- <div :style="{ minWidth: '60%' }">
          <b-input-group size="sm">
            <b-form-input
              :style="{ minWidth: '60%' }"
              v-model="termo_pesquisa"
              v-on:keyup.enter="loadData"
              placeholder="Pesquisar"
            ></b-form-input>
            <select-status
              v-model="termo_status"
              placeholder="Status"
            />
            <b-input-group-append>
              <b-button @click="loadData" variant="bagsis">
                <font-awesome-icon icon="magnifying-glass" />
                Buscar
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div> -->
      </div>
      <b-table
        striped
        hover
        :items="extratores_list"
        :fields="fields"
        :busy="isBusy"
        @sort-changed="sortingChanged"
        show-empty
        sort-icon-left
        class="list-oportunidades"
      >
        <template #cell(id)="{ item }">
          <h5>#{{ item.id }}</h5>
        </template>

        <template #cell(nome)="{ item }">
          <router-link
            :to="{ name: 'extratores_edit', params: { id: item.id } }"
          >
            <h5>{{ item.nome }}</h5>
            <span class="text-muted"># {{ item.codigo }}</span>
          </router-link>
        </template>

        <template #cell(status_exibicao)="{ item }">
          {{ item.status_exibicao ?? 'Não Visível' }}
        </template>

        <template #cell(created_at)="{ item }">
          {{ item.created_at | format_datetime }}
        </template>

        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :view_edit="$can('oportunidade:edit')"
            edit_to="oportunidades_edit"
          />
        </template>

        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>

        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </b-card>
    <div>
      <pagination-nav :pagination="pagination" @input="loadData()" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment";
import { isEqual } from "lodash";

import mixins from "@/components/Table/mixins";
import FiltersList from "@/modules/extratores/Components/FiltersList.vue";
import SelectStatus from "@/modules/extratores/Components/SelectStatus.vue";

export default {
  name: "ListExtratores",
  components: {
    FiltersList,
    SelectStatus,
  },
  mixins: [mixins],
  data: () => ({
    page: 1,
    termo_pesquisa: "",
    termo_status: null,
  }),
  computed: {
    ...mapState("extratores", ["extratores_list", "pagination"]),
    ...mapGetters("extratores", ["qualificacao_proposta"]),
    fields() {
      return [
        { key: "id", label: "COD", class: "col-1", sortable: true },
        { key: "nome", label: "Nome da oportunidade" },
        // { 
        //   key: "concedente_id",
        //   label: "Concedente",
        //   formatter: (value, head, object) => {
        //     return value;
        //     // return `R$ ${this.$options.filters.number_format(value)}`;
        //   }
        // },
        {
          key: "qualificacao_propostas",
          label: "Qualificação da proposta",
          formatter: (value, head, object) => {
            return this.$options.filters.qualificao_proposta(value);
          }
        },
        {
          key: "data_proposta_fim",
          label: "Prazo",
          class: "col-2",
          formatter: (value, head, object) => {
            return this.$options.filters.has_date(value);
          }
        },
        {
          key: "status_exibicao",
          label: "Status da oportunidade",
          class: "col-1"
        },
        {
          key: "created_at",
          label: "Data da extração",
          class: "col-1",
          sortable: true,
        },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
  methods: {
    ...mapActions("extratores", ["ActionList", "ActionDelete"]),
    async loadData() {
      try {
        this.isBusy = true;
        let payload = {
          page: this.pagination.current_page,
          per_page: this.pagination.per_page,
          orderBy: this.sortBy,
          sortBy: this.sortDesc ? "desc" : "asc",
          search: this.termo_pesquisa,
          status: this.termo_status,
        };

        if (!isEqual(this._last_request, payload)) {
          this._last_request = payload;
          await this.ActionList(payload);
        }
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      } finally {
        this.isBusy = false;
      }
    },
  },
  filters: {
    has_date: (value) => {
      if (!value) { return "-" }
      return moment(value).format('DD/MM/YYYY');
    },
    qualificao_proposta: (value) => {
      const tipos = {
        'emenda-parlamentar': 'Emenda Parlamentas',
        voluntaria: 'Voluntária',
        'especifica-concedente': 'Específica Concedente',
      };
      const key = Array.isArray(value) ? value[0] : value;
      return tipos[key] || 'Indeterminada';
    }
  },
  async mounted() {
    
  },
};
</script>

<style lang="scss">
.list-oportunidades {
  tr {
    th {
      white-space: normal !important;
    }
  }

  .cell-rec_propostas {
    font-weight: bold;
    border: 1px solid #ddd;
    padding: 0.3rem;
    text-align: center;
    color: #f5365c;
    text-transform: uppercase;

    &.cell-rec_propostas-sim {
      color: #2dce89;
    }
  }
}
</style>
